import { useState } from "react"
import { Heading, Table } from "@smooth/design-system-components"
import { dateLabel, observationLabel } from "../types"
import type { EvaluationRun } from "../types"
import { Section, TextButton } from "./parts"

/** はじめに出す件数（それより古いものは「すべて見る」で出す） */
const RECENT_RUN_COUNT = 3

const COLUMNS = [
  { key: "createdAt", header: "生成日時" },
  { key: "observation", header: "結果" },
]

/** ケースの生成履歴（API が返す最新20件のうち、はじめは直近3件）。日時を押すとその結果を上に表示する */
export function RunHistory({
  runs,
  onChoose,
}: {
  runs: EvaluationRun[]
  onChoose: (run: EvaluationRun) => void
}) {
  const [showAll, setShowAll] = useState(false)
  const shown = showAll ? runs : runs.slice(0, RECENT_RUN_COUNT)
  return (
    <Section label="生成履歴">
      <Heading level={3}>生成履歴</Heading>
      <div className="overflow-x-auto">
        <Table
          columns={COLUMNS}
          rows={shown.map((run) => ({
            createdAt: (
              <TextButton onClick={() => onChoose(run)}>{dateLabel(run.createdAt)}</TextButton>
            ),
            observation: observationLabel(run),
          }))}
        />
      </div>
      {!showAll && runs.length > RECENT_RUN_COUNT && (
        <div>
          <TextButton onClick={() => setShowAll(true)}>すべて見る（{runs.length}）</TextButton>
        </div>
      )}
    </Section>
  )
}
